export default "__VITE_ASSET__SUxI_l43__"